export default __webpack_public_path__ + "static/media/Soulcleaver.146aa6f7.jpg";